import {Controller} from "@hotwired/stimulus"
import Cropper from "cropperjs"

export default class extends Controller {
    static targets = [
        "cropperPreview",
        "cropperContainer",
        "croppedImage",
        "currentPreview"
    ]

    connect() {
        this.element.addEventListener("submit", (e) => {
            if (this.cropper) {
                const canvas = this.cropper.getCroppedCanvas({
                    width: 300,
                    height: 300
                })
                const scaledDataUrl = canvas.toDataURL("image/png")
                this.croppedImageTarget.value = canvas.toDataURL("image/png")
            }
            if (this.input) {
                this.input.disabled = true
            }
        })
    }

    handleFile(event) {
        this.input = event.target

        const file = event.target.files[0]
        if (file) {
            const reader = new FileReader()

            reader.onload = (e) => {
                this.cropperPreviewTarget.src = e.target.result
                this.cropperContainerTarget.classList.remove("hidden")

                if (this.cropper) {
                    this.cropper.destroy()
                }

                this.cropper = new Cropper(this.cropperPreviewTarget, {
                    aspectRatio: 1, // 1:1 for square images
                    viewMode: 2,
                    autoCropArea: 1,
                    zoomable: false
                })
            }

            reader.readAsDataURL(file)
        }
    }

    updatePreview() {
        if (this.cropper && this.hasCurrentPreviewTarget) {
            const canvas = this.cropper.getCroppedCanvas()
            this.currentPreviewTarget.src = canvas.toDataURL("image/png")
            this.currentPreviewTarget.classList.remove("hidden")
        }
    }
}
